// extracted by mini-css-extract-plugin
export default {"Blogs":"blog_Blogs__p+lVM"};